<template>
    <section :id="component.identifier ? component.identifier : ''"  class="pt-64 mb-64 site__container flex justify-center">
    	<div v-html="facebookFeed"></div>
    </section>
</template>

<script>
import { mapState } from 'pinia';
import { useCommonStore } from '../../state/common';
import { useBrandingStore } from '../../state/branding';
import { responsive } from '../../helpers'

export default {
    props: {
        component: {
            required: true,
        }
    },
    data: function () {
        return {}
    },
    computed: {
        ...mapState(useBrandingStore, ['preview']),
        ...mapState(useCommonStore, ['locale']),
        facebookFeed () {
            let feed = '<iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fjobtoolz&tabs=timeline&width=500&height=600&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId" width="500" height="600" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" allow="encrypted-media"></iframe>';
            let translatedUrl = this.component.translated_url[this.locale];

            let url = typeof translatedUrl && translatedUrl.indexOf('<iframe') !== -1
                ? translatedUrl
                : this.component.url;

            if (url.indexOf('<iframe') === -1) {
                return feed;
            }

            let start = url.indexOf('<iframe');

            return url.substr(start, (url.indexOf('</iframe>') + 9) - start);
        }
    },
    mounted () {
        this.$emit('loaded');
    }

}
</script>

<style scoped>

</style>
